import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Route, Link, Routes, Navigate, useLocation } from 'react-router-dom';
import { pushEvent, shouldSkipPageView } from './utils/dataLayer';

// import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css';
import './Arabic.css';


import Home from './components/pages/Home';
import Country from './components/pages/Country';
import Dealer from './components/pages/Dealer';
import Category from './components/pages/Category';
import NewAccessories from './components/pages/NewAccessories';
import Cart from './components/pages/Cart';
import Checkout from './components/pages/Checkout';
import Accessory from './components/pages/Accessory';
import Faq from './components/pages/Faq';
import Search from './components/pages/Search';
import ThreeDViewerPage from './components/pages/ThreeDViewerPage';
import { CartProvider } from './contexts/CartContext';
import AccessoriesDeepLink from './components/pages/AccessoriesDeepLink';


function PageViewTracker() {
    const location = useLocation();
    const lastPathRef = useRef('');

    useEffect(() => {
        const path = location.pathname;
        if (shouldSkipPageView(path)) return;
        if (lastPathRef.current === path) return;
        lastPathRef.current = path;
        pushEvent('page_view', {
            page_path: path + (location.search || ''),
            page_title: typeof document !== 'undefined' ? document.title : undefined,
        });
    }, [location]);

    return null;
}

function App() {

    // Run once on mount only. Missing deps [] caused this to run on every render and churn DOM/heap.
    useEffect(() => {
        const language = localStorage.getItem('language') || 'en';

        document.documentElement.lang = language === 'ar' ? 'ar' : 'en';
        document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';

        document.title = process.env.REACT_APP_WHICH_APP + ' Accessories';

        const faviconPath = '/images/' + process.env.REACT_APP_WHICH_APP + '-favicon.ico';
        let faviconLink = document.querySelector("link[rel~='icon']");
        if (!faviconLink) {
            faviconLink = document.createElement('link');
            faviconLink.type = 'image/x-icon';
            faviconLink.rel = 'shortcut icon';
            document.getElementsByTagName('head')[0].appendChild(faviconLink);
        }
        faviconLink.href = faviconPath;

        const existingLink = document.getElementById('bootstrap-stylesheet');
        if (existingLink) existingLink.remove();
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.id = 'bootstrap-stylesheet';
        link.href = language === 'ar'
            ? 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.rtl.min.css'
            : 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css';
        document.head.appendChild(link);

        const app_name = process.env.REACT_APP_WHICH_APP;
        if (app_name === 'Lincoln') {
            import('./lincoln.css').catch(err => console.error('Error loading lincoln theme CSS:', err));
        }
    }, []); // run once on mount



    return (
        <CartProvider>
            <Router>
                <PageViewTracker />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/country" element={<Country />} />
                    <Route path="/dealer" element={<Dealer />} />
                    <Route path="/accessories/:id/:name" element={<Category />} />
                    <Route path="/accessories/new" element={<NewAccessories />} />
                    <Route path="/cart" element={<Cart />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/accessory/:id/:name" element={<Accessory />} />
                    <Route path="/accessory" element={<Search />} />
                    {process.env.REACT_APP_BRAND_ID === '1' ? (
                        <Route path="/3d-viewer/:id" element={<ThreeDViewerPage />} />
                    ) : (
                        <Route path="/3d-viewer/:id" element={<Navigate to="/" replace />} />
                    )}
                    <Route path="/faq" element={<Faq />} />
                    <Route path="/dl/accessories" element={<AccessoriesDeepLink />} />
                </Routes>
            </Router>
        </CartProvider>
    );
}

export default App;